module.exports = __webpack_public_path__ + "images/88d4cc53b00e9a9ec10063e511412270.svg";